module.exports = __webpack_public_path__ + "img/vertical_6_6_0.908b4f50.png";